import React, { useMemo } from "react";
import { dayNames } from "../MonthCalendar";
import { v4 as uuidv4 } from "uuid";
import { ScheduleDay } from "./ScheduleDay";
import { CalendarEvent } from "pages/Dashboard/CalendarDayCard";

export type ScheduleEventColor = "indigo" | "sky" | "yellow" | "emerald" | "red";
interface CourseScheduleProps {
  days: {
    date: Date;
    dayNumber: number;
    dayInWeek: number;
  }[];
  events: CalendarEvent[];
  onEventClick?: (event: CalendarEvent) => void;
}
export const CourseSchedule = ({ days, events, onEventClick }: CourseScheduleProps): JSX.Element => {
  const sortedDays = useMemo(() => days.sort((a, b) => a.date.getTime() - b.date.getTime()), [days]);

  const getEvents = (date: Date) => events.filter((e) => e.eventStart.toDateString() === date.toDateString());

  return (
    <div className="overflow-hidden rounded-sm bg-white shadow dark:bg-slate-800">
      <div
        className={`grid gap-px border-b border-slate-200 dark:border-slate-700`}
        style={{
          gridTemplateColumns: `repeat(${sortedDays.length}, 1fr)`,
        }}
      >
        {sortedDays.map((day) => {
          return (
            <div className="px-1 py-3" key={uuidv4()}>
              <div className="text-center text-sm font-medium text-slate-500 lg:hidden">
                {dayNames[day.dayInWeek].substring(0, 3)}
              </div>
              <div className="hidden w-36 text-center text-sm font-medium text-slate-500 lg:block dark:text-slate-400">
                {dayNames[day.dayInWeek]}
              </div>
            </div>
          );
        })}
      </div>
      <div
        className={`grid gap-px overflow-x-auto bg-slate-200 dark:bg-slate-700`}
        style={{
          gridTemplateColumns: `repeat(${sortedDays.length}, 1fr)`,
        }}
      >
        {sortedDays.map((day) => (
          <ScheduleDay
            key={uuidv4()}
            day={day.dayNumber}
            dayDate={day.date}
            events={getEvents(day.date)}
            rowHeight="full"
            onEventClick={onEventClick}
          />
        ))}
      </div>
    </div>
  );
};
